import React, { useState } from 'react';
import { Avatar, Divider, PageHeader, Tabs, Tooltip } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import UpcomingDispatch from './UpcomingDispatch';
import CompletedDispatch from './CompletedDispatch';
import NotificationsPanel from 'containers/NotificationsPanel';

const Dispatches = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);

  const tabItems = [
    // remember to pass the key prop
    {
      label: 'Ongoing',
      key: 'ongoing-dispatches',
      children: <UpcomingDispatch tab={tab} />,
    },
    {
      label: 'Completed',
      key: 'completed-dispatches',
      children: <CompletedDispatch tab={tab} />,
    },
  ];

  const hideNotification = () => {
    setShowNotification(!showNotification);
  };

  return (
    <div className="app-container">
      <PageHeader
        onBack={() => null}
        backIcon={null}
        title={
          <div className=".d-inline" style={{ marginLeft: '10 px' }}>
            Dispatches
          </div>
        }
        className="py-sm-4 page-header"
        extra={
          <Tooltip title="Notifications">
            <Avatar src={require('assets/images/notification.png')} size="small" className="cursor-pointer mx-2" onClick={() => setShowNotification(!showNotification)} />
          </Tooltip>
        }
      />

      <Tabs className="my-4" type="line" items={tabItems} defaultActiveKey={tab} onChange={(key) => navigate(`/dispatches/${key}`)} />

      <Divider />
      <NotificationsPanel visible={showNotification} close={hideNotification} />
    </div>
  );
};

export default Dispatches;
